<template>
  <nav class="navbar">
    <div class="navbar-container">
      <router-link to="/" class="logo" @click="closeMenu">
        <img src="@/assets/logo-white.svg" alt="Logo" class="h-8 w-auto mr-3" />
        <span>TrackFolio</span>
      </router-link>
      
      <button class="mobile-menu-btn" @click="toggleMenu" aria-label="Toggle menu">
        <svg v-if="!isMenuOpen" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <div class="nav-links" :class="{ 'active': isMenuOpen }">
        <router-link 
          to="/portfolios" 
          class="nav-link"
          active-class="active"
          @click="closeMenu"
        >
          Portfolios
        </router-link>
        <router-link 
        id="nav-net-worth"
          to="/net-worth" 
          class="nav-link"
          active-class="active"
          @click="closeMenu"
        >
          Net Worth
        </router-link>
        <router-link 
          id="nav-liabilities"
          to="/liabilities" 
          class="nav-link"
          active-class="active"
          @click="closeMenu"
        >
          Liabilities
        </router-link>
        <router-link 
          id="nav-custom-symbols"
          to="/custom-symbols" 
          class="nav-link"
          active-class="active"
          @click="closeMenu"
        >
          Personal Assets
        </router-link>
        <router-link 
          to="/market" 
          class="nav-link"
          active-class="active"
          @click="closeMenu"
        >
          Market
        </router-link>

        <router-link 
          v-if="isAdmin"
          to="/admin" 
          class="nav-link admin-link"
          active-class="active"
          @click="closeMenu"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 inline mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          Admin
        </router-link>

        <button 
          @click="toggleTheme" 
          class="theme-toggle-btn" 
          :aria-label="theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'"
        >
          <svg v-if="theme === 'light'" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
          </svg>
        </button>

        <div class="user-profile-container">
          <UserProfile />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import UserProfile from './UserProfile.vue'
import { useTheme } from '@/composables/useTheme'
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'NavBar',
  components: {
    UserProfile
  },
  setup() {
    const { theme, toggleTheme } = useTheme()
    const store = useStore()
    const isAdmin = computed(() => store.getters['auth/isAdmin'])
    return { theme, toggleTheme, isAdmin }
  },
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    }
  }
}
</script>

<style scoped>
.navbar {
  background: rgb(var(--color-primary-600));
  box-shadow: 0 2px 4px rgb(var(--color-primary-600) / 0.3);
  padding: 1rem 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.navbar-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-size: 1.5rem;
  font-weight: bold;
  color: #ffffff;
  text-decoration: none;
  display: flex;
  align-items: center;
}

.nav-links {
  display: flex;
  gap: 2rem;
  align-items: center;
}

.nav-link {
  text-decoration: none;
  color: #ffffff;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.nav-link:hover {
  background: rgb(var(--color-primary-500));
}

.nav-link.active {
  background: rgb(var(--color-primary-700));
  color: #ffffff;
}

.admin-link {
  display: flex;
  align-items: center;
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.admin-link:hover {
  background: rgba(239, 68, 68, 0.25) !important;
}

.theme-toggle-btn {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.5rem;
  color: white;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.theme-toggle-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.mobile-menu-btn {
  display: none;
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0.5rem;
}

.mobile-menu-btn:focus {
  outline: none;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .mobile-menu-btn {
    display: block;
  }

  .nav-links {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: rgb(var(--color-primary-600));
    flex-direction: column;
    align-items: flex-start;
    padding: 1rem;
    gap: 1rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    display: none;
  }

  .nav-links.active {
    display: flex;
    animation: slideDown 0.3s ease-out;
  }

  .nav-link {
    width: 100%;
    display: block;
  }

  .user-profile-container {
    width: 100%;
    padding-top: 0.5rem;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
